export default function ForbidentView() {
  return <>403</>;
}
